import { BaseContent } from '@fourthwall/components';
import React from 'react';
import * as S from './LoginPlatform.styled';
export const LoginPlatform = ({ image, provider, username }) => (React.createElement(S.Container, null,
    React.createElement("div", null,
        React.createElement(S.ProviderImage, { src: image, alt: provider })),
    React.createElement("div", null,
        React.createElement(BaseContent, null,
            React.createElement("strong", null, provider))),
    React.createElement(S.Username, null,
        React.createElement(BaseContent, { appearance: "secondary", size: "small" }, username))));
